import { loader } from 'graphql.macro'

export default async function createTermsAndCondition ({ dataLoaders, variables }) {
  const schema = loader('./createTermsAndCondition.graphql')
  const response = await dataLoaders.dispatcher.graphQLClient.request(schema, {
    input: {
      haulerId: variables.haulerId,
      input: variables.input
    }
  })
  return response.createTermsAndCondition
}
